import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const STATE = ['archive', 'unarchive']
const TYPE = ['group', '1on1']

export const schema = Joi.object().keys({
  classId: Joi.number().integer().required(),
  type: Joi.string().valid(TYPE),
  state: Joi.string().valid(STATE),
});

export default function updateClass(opts) {

  let validateResult = Joi.validate(opts, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  const type = TYPE.indexOf(opts.type);

  let toServer = {
    ...opts,
    state: STATE.indexOf(opts.state)
  }


  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/u_clsstt/${opts.classId}/${type}/`,
		'method': 'PUT',
		'data': JSON.stringify(toServer),
		'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/class/updateClass.js